import React from 'react'
import { IResponseNewsCrawlerDetail } from '@interfaces/iresponse-news-crawler'
import moment from 'moment'
import { Button, Form, FormItem, htmlRender } from 'asumsi-components'
import { Modal, Select } from 'antd'
import { IParamUpdateNewsCrawler } from '@interfaces/iparam-news-crawler'
import TextArea from 'antd/lib/input/TextArea'

type Props = {
  detail: IResponseNewsCrawlerDetail
  showDetail: boolean
  setShowDetail: React.Dispatch<React.SetStateAction<boolean>>
  loading: boolean
  topicsOptions: any
  fieldValues: IParamUpdateNewsCrawler
  setFieldValues: React.Dispatch<IParamUpdateNewsCrawler>
  onChangeReason: (e: React.ChangeEvent<HTMLElement>) => void
  onPublish: Function
  onUnpublish: Function
  onCancelUpdate: Function,
  fetchTopicList: (value?: string) => Function
}

export const NewsCrawlerDetail = ({
  detail,
  loading,
  setShowDetail,
  showDetail,
  fieldValues,
  setFieldValues,
  topicsOptions,
  onChangeReason,
  onPublish,
  onUnpublish,
  onCancelUpdate,
  fetchTopicList
}: Props) => {
  const onCancel = () => {
    setShowDetail(false)
    onCancelUpdate()
  }

  const onChangeTopic = (value: string) => {
    if (!value) {
      fetchTopicList();
    }
    setFieldValues({ ...fieldValues, topicIdDetail: value });
  }

  return (
    <Modal
      visible={showDetail}
      title="Quickview"
      confirmLoading={loading}
      width={1000}
      onCancel={onCancel}
      footer={detail && detail.status === 'published' ? (
        <Form>
          <FormItem>
            <TextArea
              placeholder="Reason of unpublish"
              className="width-100"
              allowClear={false}
              rows={2}
              onChange={onChangeReason}
              value={fieldValues.reason}
            />
          </FormItem>
          <Button onClick={() => {
            onUnpublish()
            setShowDetail(false)
          }} size='medium' text="Unpublish" type='outline-red' />
        </Form>
      ) : (
          <Form>
            <FormItem
              fieldsValues={fieldValues}
              fieldDecorator={{
                label: 'topicIdDetail',
                rules: [{
                  message: 'Please select topic',
                  required: true
                }]
              }}
              label="Topic"
              setFieldsValues={setFieldValues}
            >
              <Select
                id="topicIdDetail"
                style={{ width: "100%" }}
                allowClear
                onSearch={fetchTopicList}
                showSearch
                optionFilterProp="children"
                defaultValue={fieldValues.topicIdDetail}
                value={fieldValues.topicIdDetail}
                onChange={onChangeTopic}
                placeholder="Please select topic"
              >
                {topicsOptions}
              </Select>
            </FormItem>
            <Button onClick={() => {
              onPublish()
              setShowDetail(false)
            }} size='medium' text="Publish" type='green' />
          </Form>
        )}
    >
      {
        detail && (
          <div>
            <section id="meta" style={{ display: 'flex' }}>
              {
                detail.featuredImage?.url &&
                <img style={{ margin: '0px 10px 20px 10px' }} width={200} src={detail.featuredImage?.url} alt={detail.featuredImage?.title} />

              }
              <p style={{ marginLeft: '10px' }}>
                <span>{detail.newsMedia?.name} - {moment(new Date(detail.postedDate)).format('DD MMMM yyyy')}</span>
                <h3>{detail.title}</h3>
                <div style={{ display: 'flex' }}>
                  {
                    detail.author &&
                    <p className="m-r-10">
                      <span>Author</span>
                      <h4>{detail.author.name}</h4>
                    </p>
                  }
                  {
                    detail.editor &&
                    <p>
                      <span>Editor</span>
                      <h4>{detail.editor.name}</h4>
                    </p>
                  }
                </div>
              </p>
            </section>
            <div style={{
              height: '300px',
              overflowY: 'scroll',
              overflowX: 'hidden'
            }}>
              {htmlRender(detail.content)}
            </div>
          </div>
        )
      }
    </Modal>
  )
}


// WEBPACK FOOTER //
// ./src/pages/news-crawler/libraries/detail.tsx